import React, { createContext, useEffect, useState } from "react";
import axios from "../api/axiosInstance";

export const LocationContext = createContext();

export const LocationProvider = ({ children }) => {

  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [address, setAddress] = useState("");

useEffect(() => {

  if (!navigator.geolocation) {
    console.log("Geolocation not supported");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {

      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      console.log("GPS:", latitude, longitude);

      setLat(latitude);
      setLng(longitude);

      try {
        const res = await axios.get(
          `/reverse-geocode/?lat=${latitude}&lng=${longitude}`
        );

        console.log("ADDRESS API:", res.data);

        if (res.data?.address) {
          setAddress(res.data.address);
        }

      } catch (e) {
        console.error("Reverse geocode failed:", e);
      }

    },

    (error) => {
      console.error("Location error:", error);
      setAddress("Location permission denied or GPS unavailable");
    },

    {
      enableHighAccuracy: true,
      timeout: 15000,
      maximumAge: 0
    }

  );

}, []);

  return (
    <LocationContext.Provider value={{ lat, lng, address }}>
      {children}
    </LocationContext.Provider>
  );
};